var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 24c0 9.389-7.611 17-17 17-5.651 0-10.658-2.757-13.75-7H13a1 1 0 1 0 0-2H8.996A16.925 16.925 0 0 1 7 24c0-9.389 7.611-17 17-17 5.651 0 10.658 2.757 13.75 7H35a1 1 0 1 0 0 2h4.004A16.925 16.925 0 0 1 41 24zM24 43c-6.824 0-12.808-3.598-16.159-9H1a1 1 0 1 1 0-2h5.761A18.928 18.928 0 0 1 5 24C5 13.507 13.507 5 24 5c6.824 0 12.808 3.598 16.159 9H47a1 1 0 1 1 0 2h-5.761A18.928 18.928 0 0 1 43 24c0 10.493-8.507 19-19 19zM3 7a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm40 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm-19 0a13 13 0 0 0-12.75 15.536 1 1 0 0 1-1.962.39A15 15 0 0 1 24 9a1 1 0 1 1 0 2zm14 12a1 1 0 0 1 1 1 15 15 0 0 1-17.926 14.712 1 1 0 0 1 .39-1.962A13 13 0 0 0 37 24a1 1 0 0 1 1-1zm-13-7a1 1 0 1 0-2 0v8.535l.445.297 6 4a1 1 0 0 0 1.11-1.664L25 23.465V16z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeTime);
export default __webpack_public_path__ + "static/media/welcome_time.b9851c54edeb7bcf0fea214014ba407b.svg";
export { ForwardRef as ReactComponent };